"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreviewCamera = void 0;
const validation_1 = require("../../validation");
var PreviewCamera;
(function (PreviewCamera) {
    PreviewCamera["STATIC"] = "static";
    PreviewCamera["INTERACTIVE"] = "interactive";
})(PreviewCamera = exports.PreviewCamera || (exports.PreviewCamera = {}));
/** @alpha */
(function (PreviewCamera) {
    PreviewCamera.schema = {
        type: 'string',
        enum: Object.values(PreviewCamera)
    };
    PreviewCamera.validate = (0, validation_1.generateLazyValidator)(PreviewCamera.schema);
})(PreviewCamera = exports.PreviewCamera || (exports.PreviewCamera = {}));
//# sourceMappingURL=preview-camera.js.map